/**
 * @group Components
 * @summary <blockquote>UncheckedSquare icon component.</blockquote>
 * @example
 * ```tsx
 * <UncheckedSquare />
 * ```
 */
export const UncheckedSquare = ({ size = 16 }: { size?: number }) => {
        return (
          <svg
            height={size}
            strokeLinejoin="round"
            viewBox="0 0 16 16"
            width={size}
            style={{ color: 'currentcolor' }}
          >
            <rect
              x="1"
              y="1"
              width="14"
              height="14"
              stroke="currentColor"
              strokeWidth="1.5"
              fill="none"
            />
          </svg>
        );
      };